var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-col',{staticClass:"ma-0 pt-0"},[_c('v-row',{staticClass:"ma-0 pa-0"},[_c('v-spacer'),_c('v-btn',{attrs:{"color":_vm.getAppearances.btn_color,"dark":""},on:{"click":function($event){return _vm.createUser()}}},[_vm._v(" Create user ")])],1),_c('Users')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }